<app-public-mit-shell [logoUrl]="mandate()?.merchantLogoUrl" [merchantName]="mandate()?.merchantName">
  @switch (view()) {
    @case ('loading') {
      <div class="flex-1 flex items-center justify-center min-h-[50vh]">
        <div class="inline-block animate-spin rounded-full h-10 w-10 border-2 border-slate-200 border-t-slate-600"></div>
      </div>
    }
    @case ('invalid') {
      <div class="bg-white rounded-2xl shadow-sm border border-slate-200 p-10 text-center">
        <i class="pi pi-exclamation-triangle text-3xl text-red-400"></i>
        <p class="text-slate-800 font-semibold mt-3 mb-0">Liga inválida o vencida</p>
      </div>
    }
    @case ('none') {
      <div class="bg-white rounded-2xl shadow-sm border border-slate-200 p-10 text-center">
        <i class="pi pi-info-circle text-3xl text-slate-400"></i>
        <p class="text-slate-800 font-semibold mt-3 mb-1">No hay cambios de límites por aceptar</p>
        <p class="text-sm text-slate-500 m-0">La propuesta ya se aceptó o venció. Si la necesitas, pide al comercio que la envíe de nuevo.</p>
      </div>
    }
    @case ('accepted') {
      <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="bg-emerald-600 px-6 py-6 text-center">
          <i class="pi pi-check-circle text-3xl text-white"></i>
          <p class="text-white font-bold text-lg mt-2 mb-0">Nuevos límites aceptados</p>
        </div>
        <div class="px-6 py-5 text-sm">
          <p class="m-0 mb-2 text-slate-700">{{ mandate()?.merchantName }} podrá cobrarte dentro de estos límites:</p>
          <ul class="m-0 pl-4 list-disc text-slate-700">
            @for (row of newRows(); track row.label) {
              <li>{{ row.label }}: <strong>{{ row.value }}</strong></li>
            }
          </ul>
        </div>
      </div>
    }
    @case ('form') {
      @if (mandate(); as m) {
        <section class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          <div class="bg-gradient-to-br from-slate-800 to-slate-900 px-6 py-5">
            <p class="text-slate-300 text-xs uppercase tracking-widest m-0">Aumento de límites</p>
            <h1 class="text-white text-xl font-bold leading-tight mt-1 mb-0">{{ m.merchantName }}</h1>
            <p class="text-slate-300 text-sm mt-1 mb-0">{{ m.purpose }}</p>
          </div>
          <div class="px-6 py-5 flex flex-col gap-4 text-sm">
            <p class="m-0 text-slate-700">
              El comercio te pide aceptar nuevos límites. Hasta que los aceptes, seguirá cobrando dentro de los actuales.
              Tienes hasta el <strong>{{ m.pendingLimitsExpiresAt | date:'dd/MM/yyyy HH:mm' }}</strong>.
            </p>
            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="text-xs text-slate-500">
                    <th class="text-left font-medium pb-2">Límite</th>
                    <th class="text-right font-medium pb-2">Actual</th>
                    <th class="text-right font-medium pb-2">Propuesto</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                  @for (item of rows(); track item.row.key) {
                    <tr [class.bg-amber-50]="item.raised">
                      <td class="py-2 pl-1 text-slate-600">{{ item.row.label }}</td>
                      <td class="py-2 text-right text-slate-800">{{ item.current }}</td>
                      <td class="py-2 pr-1 text-right" [class.font-semibold]="item.raised" [class.text-amber-800]="item.raised">
                        {{ item.proposed }}
                        @if (item.raised) { <i class="pi pi-arrow-up text-[10px]"></i> }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (m.termsText) {
              <div class="rounded-xl border border-slate-200 bg-white">
                <p class="text-[10px] uppercase tracking-widest text-slate-400 px-4 pt-3 m-0">Términos</p>
                <div class="px-4 py-3 max-h-56 overflow-y-auto text-xs text-slate-700 whitespace-pre-line leading-relaxed">{{ m.termsText }}</div>
              </div>
            }
            <label class="flex items-start gap-3 text-sm text-slate-700 cursor-pointer">
              <input type="checkbox" class="mt-0.5 h-4 w-4 rounded border-slate-300" [ngModel]="accepted()" (ngModelChange)="accepted.set($event)" />
              <span>Acepto los nuevos límites propuestos por <strong>{{ m.merchantName }}</strong>.</span>
            </label>
            @if (error()) {
              <div class="bg-red-50 border border-red-200 rounded-lg px-4 py-3 text-sm text-red-700">{{ error() }}</div>
            }
            <button type="button" (click)="accept()" [disabled]="!accepted() || sending()"
              class="flex items-center justify-center gap-2 w-full py-3 px-4 rounded-xl bg-slate-800 hover:bg-slate-700 text-white text-sm font-bold transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
              @if (sending()) { <i class="pi pi-spin pi-spinner"></i> } Aceptar nuevos límites
            </button>
          </div>
        </section>
      }
    }
  }
</app-public-mit-shell>
